var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ChartFrame',{attrs:{"title":_vm.name}},[_c('ApexChart',{attrs:{"options":_vm.options,"series":_vm.sheets[0].series.map(function (s) { return ({ data: s.data, name: _vm.$t(s.name) }); }),"height":_vm.height}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }